import { pilot } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';

interface Request {
  clientId: string;
  sortOrder: { id: PilotId; position: number }[];
}

export const reorderClientSectionsData = async ({
  clientId,
  sortOrder,
}: Request) => {
  return pilot.put(`client/${clientId}/section-order/`, sortOrder);
};
